import { APPLICATION_TITLE } from '@/Module/Core/Constant';
import { replaceHalfSpace } from '@/Module/Core/Helper';

export const preparePageTitle = (pageTitle: string) => {
  return replaceHalfSpace(`${pageTitle} | ${APPLICATION_TITLE}`);
};
